import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import InvoiceView from '@/views/InvoiceView.vue';
import HomeView from "@/views/HomeView.vue";
import SuccessView from "@/views/SuccessView.vue";
import TokenGenerator from "@/views/TokenGenerator.vue"; // Your InvoiceView component

// Define your routes
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/invoice', // Define the route to the invoice view
        name: 'invoice',
        component: InvoiceView
    },
    {
        path: '/success',
        name: 'success',
        component: SuccessView
    },
    {
        path: '/demotoken',
        name: 'demotoken',
        component: TokenGenerator
    },
];

// Create a router instance using createRouter
const router = createRouter({
    history: createWebHistory(), // Use history mode to avoid hash in URL
    routes, // Short for `routes: routes
});

// Export the router instance
export default router;